<template>
  <div>
    <keep-alive>
      <router-view
        v-if="
          $route.meta.keepAlive &&
            Util.isNotEmpty(gts2CustomerId) &&
            Util.isNotEmpty(platform)
        "
      />
    </keep-alive>
    <router-view
      v-if="
        !$route.meta.keepAlive &&
          Util.isNotEmpty(gts2CustomerId) &&
          Util.isNotEmpty(platform)
      "
      :key="componentKey"
    />
    <!--登录失效-->
    <div v-if="loginInvalid" class="popFixed">
      <div class="masking" />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p>登录已失效，请重新登录！</p>
        </div>
        <div class="btnCon only">
          <span @click="goLogin">重新登录</span>
        </div>
      </div>
    </div>
    <DisclosureAudio v-if="showDisclosure" :read-disclosure="readDisclosure" />
  </div>
</template>

<script>
import api from '@/plugins/api'
import utils from '@/utils/tradeDataUtil'
import DisclosureAudio from '@/view/disclosure/DisclosureAudio'
import { mapState } from 'vuex'

export default {
  name: 'InitData',
  components: { DisclosureAudio },
  data() {
    return {
      loginInvalid: false,
      showDisclosure: false,
      Util: utils,
      componentKey: 0
    }
  },
  computed: {
    ...mapState(['gts2CustomerId', 'platform', 'user'])
  },
  beforeCreate() {
    this.$store.dispatch('setAltFlavors', [])
    this.$store.dispatch('setTabIndex', 0)
  },
  async created() {
    await this.getAltFlavors()
  },
  mounted() {
    this.accTradeInfo(this.gts2CustomerId)
    setInterval(() => {
      this.accTradeInfo(this.gts2CustomerId)
    }, 7800000)
  },
  methods: {
    goLogin() {
      localStorage.clear()
      this.$store.dispatch('setUser', {})
      this.$store.dispatch('setTokenCookie', {})
      window.location.href = process.env.VUE_APP_PATH + 'login'
    },
    accTradeInfo(data) {
      api.getAccTradeInfo(data).then((res) => {
        if (res.data.code == 200) {
          const accountNoList = []
          const platformList = []
          const currencyList = []
          const AccountIdList = []
          const platformNameList = []
          const accTradeInfoList = res.data.data.accTradeInfoList
          for (const i in accTradeInfoList) {
            accountNoList.push(accTradeInfoList[i].accountNo)
            platformList.push(accTradeInfoList[i].platform)
            currencyList.push(accTradeInfoList[i].currency)
            AccountIdList.push(accTradeInfoList[i].gts2AccountId)
            platformNameList.push(accTradeInfoList[i].platformName)
          }

          this.$store.dispatch('setAccountNo', accountNoList[0])
          this.$store.dispatch('setPlatform', platformList[0])
          this.$store.dispatch('setPlatformName', platformNameList[0])
          this.$store.dispatch('setCurrency', currencyList[0])
          this.$store.dispatch('setGts2AccountId', AccountIdList[0])
          const accountInfo = {
            chineseName: res.data.data.accountInfo.chineseName
              ? res.data.data.accountInfo.chineseName
              : '',
            idDocumentNumber: res.data.data.accountInfo.idDocumentNumber,
            cashoutTag: res.data.data.accountInfo.paySwitchCashoutSeqTagCode
          }
          this.$store.dispatch('setAccountInfo', accountInfo)
          if (res.data.data.accTradeInfoList[0].remindRisk === '1') {
            this.showDisclosure = true
          }
        } else if (
          res.data.code == 401 &&
          res.data.code_desc == 'token.error'
        ) {
          this.loginInvalid = true
          localStorage.clear()
          this.$store.dispatch('setUser', {})
          this.$store.dispatch('setTokenCookie', {})
        }
      })
    },
    readDisclosure() {
      this.showDisclosure = false
    },
    async getAltFlavors() {
      const { data } = await api.getAllAppChannels()
      if (data.code !== 0 || !data.result) {
        return
      }
      this.$store.dispatch('setAltFlavors', data.result.map(item => item.flavor))

      // Force re-render child view components as the components may have rendered first before API call finished
      this.componentKey += 1
    }
  }
}
</script>
